import LegalLayout from "./LegalLayout";

export default function Terms() {
  const effective = "February 2026";
  return (
    <LegalLayout
      title="Terms of Service"
      subtitle={`Effective ${effective}. This is a template — please review with a lawyer before public launch.`}
    >
      <p>
        Welcome to Accountrix. These Terms of Service (&quot;Terms&quot;) govern your use of the Accountrix web application and services (the &quot;Service&quot;). By creating an account or using the Service you agree to these Terms. If you do not agree, please do not use the Service.
      </p>

      <h2>1. The Service</h2>
      <p>
        Accountrix is a personal-finance tracking tool. It lets you record and categorise transactions, set budgets and savings goals, connect bank accounts through Plaid or Mono, track investments, receive AI-generated insights, and export monthly reports. Features may change over time as we improve the product.
      </p>

      <h2>2. Your account</h2>
      <ul>
        <li>You must be at least 16 years old to use Accountrix.</li>
        <li>You are responsible for keeping your password confidential and for all activity under your account.</li>
        <li>Provide accurate information and keep it up to date.</li>
        <li>Notify us immediately of any unauthorised access via the email associated with your account.</li>
      </ul>

      <h2>3. Not financial advice</h2>
      <p>
        <b>Accountrix is not a financial institution, broker, tax advisor, or investment adviser.</b> The AI insights, weekly digests, budget alerts, and any analytics we present are informational and generated automatically. They are <b>not</b> professional financial, legal, or tax advice. Investment prices shown are provided by third parties (CoinGecko, Yahoo Finance) and may be delayed or inaccurate — never use them for trading decisions. Consult a qualified professional before making significant financial decisions.
      </p>

      <h2>4. Bank connections</h2>
      <p>
        If you link a bank account, you also agree to the terms of the underlying provider (Plaid or Mono). You authenticate directly with them; we never store your online-banking credentials. You can unlink at any time in the app, which revokes our access token.
      </p>

      <h2>5. Your data</h2>
      <p>
        You retain ownership of the financial data you enter. You grant us a limited, revocable licence to store, process, transmit, and display that data solely to operate the Service for you. See our <a href="/privacy">Privacy Policy</a> for full details on collection and use.
      </p>

      <h2>6. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for anything illegal, fraudulent, or infringing.</li>
        <li>Attempt to reverse-engineer, scrape, or circumvent security controls.</li>
        <li>Upload malicious code or data that isn&apos;t yours.</li>
        <li>Automate access in ways that place undue load on the Service (see rate limits).</li>
        <li>Impersonate anyone or misrepresent your identity.</li>
      </ul>

      <h2>7. Fees</h2>
      <p>
        The core Service is currently free. We may introduce paid tiers in the future; if we do, you&apos;ll be notified at least 30 days before any paid feature becomes mandatory and will always have the option to export your data.
      </p>

      <h2>8. Demo accounts</h2>
      <p>
        &quot;Try demo&quot; creates a temporary account seeded with sample data. Demo accounts are automatically deleted 24 hours after creation. Do not use demo accounts for real financial tracking.
      </p>

      <h2>9. Availability, changes, and termination</h2>
      <ul>
        <li>We strive for high availability but do not guarantee uninterrupted service.</li>
        <li>We may modify or discontinue features, with reasonable notice for material changes.</li>
        <li>You may delete your account at any time.</li>
        <li>We may suspend or terminate an account that violates these Terms or applicable law.</li>
      </ul>

      <h2>10. Disclaimers</h2>
      <p>
        THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT THIRD-PARTY DATA (INCLUDING PRICES AND BANK DATA) WILL BE ACCURATE OR TIMELY.
      </p>

      <h2>11. Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, LEDGER AND ITS OPERATORS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR DATA, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE.
      </p>

      <h2>12. Indemnification</h2>
      <p>
        You agree to indemnify and hold Accountrix and its operators harmless from any claims arising from your misuse of the Service or your violation of these Terms.
      </p>

      <h2>13. Governing law &amp; disputes</h2>
      <p>
        These Terms are governed by the laws of the operator&apos;s primary jurisdiction (please replace this clause with a specific jurisdiction that suits your business, e.g., &quot;the laws of the State of Delaware, USA&quot;). Disputes will be resolved in the courts of that jurisdiction unless required otherwise by local law.
      </p>

      <h2>14. Changes to these Terms</h2>
      <p>
        We may update these Terms occasionally. Material changes will be announced by email or in-app notification at least 14 days before they take effect. Continued use of the Service after changes constitutes acceptance.
      </p>

      <h2>15. Contact</h2>
      <p>
        Questions or notices under these Terms? Email us from the address associated with your Ledger account. We aim to respond within 5 business days.
      </p>
    </LegalLayout>
  );
}
